<template>
  <router-view />
</template>

<script>
export default {
  data() {
    return {};
  },
  watch: {
    '$route.params.customer_id': {
      immediate: true,
      handler: function (newCustomerId, oldCustomerId) {
        this.$store.commit('setSelectedCustomer', undefined);
        this.$store.commit('setCustomerLoading', true);
        if (this.$route.params.customer_id) {
          this.$store
            .dispatch('getCustomer', this.$route.params.customer_id)
            .then((response) => {
              this.$store.commit('setSelectedCustomer', response.data);
              this.$store.commit('setCustomerLoading', false);
            })
            .catch(() => {
              this.$store.commit('setCustomerLoading', false);
              this.$store.commit('setSelectedCustomer', undefined);
            });
        }
      },
    },
  },
  beforeDestroy() {
    this.$store.commit('setSelectedCustomer', undefined);
  },
};
</script>

<style lang="scss">
.red-banner {
  height: 50px;
  margin: 0 auto;
  background: red;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px;
  z-index: 100000;
  opacity: 80%;
  color: #fff;
  text-align: center;
  border-radius: 5px 5px 0px 0px;
  font-size: 2.2vmin;

  &:hover {
    display: none;
  }
}
</style>
